import { useMutation } from 'react-query';
import { inventoryService, removeCache } from '../../../services';

export const useAddInventoryMutation = () => {
  return useMutation(
    (props: any) => {
      props.assignedTo = props.assignedTo.map((item: any) => ({
        userId: item.userId,
        blocks: item.blocks.map((block: any) => ({
          block: block.block,
        })),
      }));

      return inventoryService.add(props);
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'key']);
      },
    },
  );
};

export const useUpdateInventoryMutation = () => {
  return useMutation(
    (props: any) => {
      props.assignedTo = props.assignedTo.map((item: any) => ({
        userId: item.userId,
        blocks: item.blocks.map((block: any) => ({
          block: block.block,
        })),
      }));

      return inventoryService.update(props);
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'key']);
      },
    },
  );
};

export const useUpdateInventoryItemMutation = () => {
  return useMutation(
    (props: any) => {
      return inventoryService.itemUpdate(props);
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'yard']);
      },
    },
  );
};

export const useCompleteInventoryMutation = () => {
  return useMutation(
    (props: any) => {
      return inventoryService.complete(props);
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'key']);
      },
    },
  );
};

export const useDeleteInventoryMutation = () => {
  return useMutation(
    (props: any) => {
      return inventoryService.delete(props);
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'key']);
      },
    },
  );
};
